import React from "react";
import { Autocomplete, TextField } from "@mui/material";

const SearchAutoComplete = ({
  labelName = "Search",
  data = [],
  setSelectedEmp = () => { },
  handelAssigneUpdate = () => { },
  isCreateIssuePage = false
}) => {
  const findUser = (value) =>
    data.find((emp) => (emp.email ? emp.email === value : emp.employeeEmail === value));

  const handleSelectionChange = (event, value) => {
    const selectedUser = findUser(value);
    if (selectedUser) {
      setSelectedEmp(selectedUser);
      handelAssigneUpdate(selectedUser);
    }
  };

  /**
   * Picking an option fires onChange and then onInputChange. Without looking
   * the value up again here, that second call replaced the chosen user with a
   * bare { employeeEmail }, dropping the _id — so an existing member was
   * invited as if they were a new signup and was saved with a null employeeId.
   * Free text still falls back, which is what invites-by-email rely on.
   */
  const handleInputChange = (event, value) => {
    setSelectedEmp(findUser(value) || { employeeEmail: value });
  };

  return (
    <div>
      <Autocomplete
        freeSolo
        id="free-solo-2-demo"
        className="search-bar"
        disableClearable
        sx={{ minWidth: isCreateIssuePage ? '200px' : "250px" }}
        options={data.map((emp) => (emp.email ? emp.email : emp.employeeEmail))}
        onChange={handleSelectionChange}
        onInputChange={handleInputChange}
        renderInput={(params) => (
          <TextField
            {...params}
            label={labelName}
            InputProps={{
              ...params.InputProps,
              type: "search",
            }}
            size="small"
          />
        )}
      />
    </div>
  );
};

export default SearchAutoComplete;
